import { Alert, Button, Stack, Typography } from "@mui/material";

import { normalizeErrorMessages } from "api/common/utils/rtkq.utils";
import { useCreateMailUserMutation } from "api/memberPortal/mailList/mailList.api";
import { MailAccount } from "api/memberPortal/mailList/mailList.types";
import { useAppForm } from "components/Forms/AppForm";
import CreateMemberFields from "features/memberPortal/mail/components/MailListMembers/components/MailListCreateMember/CreateNewMember.fields";

import {
  createMemberSchema,
  CreateMemberSchemaValues,
} from "./CreateMember.schema";

interface CreateMemberFormProps {
  onClose: () => void;
  onUserCreated: (_user: MailAccount) => void;
}

export default function CreateMemberForm({
  onClose,
  onUserCreated,
}: CreateMemberFormProps) {
  const [createUser, { isLoading, error }] = useCreateMailUserMutation();

  const memberForm = useAppForm({
    defaultValues: {
      name: "",
      email: "",
    } as CreateMemberSchemaValues,

    validators: {
      onSubmit: createMemberSchema,
    },
    onSubmit: async ({ value }) => {
      const user = await createUser({
        name: value.name,
        email: value.email,
      });
      if (!("error" in user)) {
        onUserCreated(user.data);
        onClose();
      }
    },
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        memberForm.handleSubmit();
      }}
    >
      <Stack spacing={1.5} sx={{ p: 2 }}>
        <Typography variant="subtitle2">Create new user</Typography>

        <CreateMemberFields
          form={memberForm}
          fields={{ name: "name", email: "email" }}
        />
        {error && (
          <Alert severity="error" sx={{ py: 0 }}>
            {normalizeErrorMessages(error)}
          </Alert>
        )}

        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button
            size="small"
            onClick={onClose}
            disabled={isLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
            loading={isLoading}
          >
            Create
          </Button>
        </Stack>
      </Stack>
    </form>
  );
}
